<template>
    <div class="about" v-loading="processing">
        <h1>Terms & Conditions</h1>
        <div v-html="data"></div>
    </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
    name: "TermsConditions",
    components: {
    },
    data() {
        return {
            data: '',
            processing: false,
        };
    },
    mounted() {
        this.loadData();
    },
    methods: {
        ...mapActions(["request", "getError"]),
        loadData() {
            let ctrl = this;
            ctrl.processing = true;
            ctrl.request({
                method: "GET",
                endpoint: `site_content/tc`
            })
                .then(({ data = {} }) => {
                  if(data.results.length > 0) {
                    this.data = data.results[0].description;
                  }
                })
                .catch(err => {
                    ctrl.getError({
                        err,
                    }).then(ctrl.$notify);
                })
                .finally(() => {
                    setTimeout(() => {
                        ctrl.processing = false;
                    }, 500);
                });
        },
    }
};
</script>
<style scoped>
.about {
  padding: 16px 48px;
  color: #444;
  max-width: 800px;
  line-height: 24px;
}
p {
  margin: 24px 0px;
}
</style>